__turbopack_context__.v({
  "followButton": "FollowButton-module-scss-module__RlrSKa__followButton",
  "following": "FollowButton-module-scss-module__RlrSKa__following",
  "organizer": "FollowButton-module-scss-module__RlrSKa__organizer",
  "textContainer": "FollowButton-module-scss-module__RlrSKa__textContainer",
});
